import classNames from "classnames";
import React from "react";
import {
    UncontrolledPopover,
    UncontrolledPopoverRef,
} from "tsi-common-react/src/common/Popover";

interface IProps {
    id: string;
    labelText: string;
    onAfterClose?: () => void;
    onAfterOpen?: () => void;
    children?: React.ReactNode;
    ref?: React.Ref<{ onRequestClose: () => void }>;
}

export const LocatorFilterPopover = (props: IProps): React.ReactNode => {
    const { ref, id, labelText, onAfterClose, onAfterOpen, children } = props;
    const popperElem = React.useRef<UncontrolledPopoverRef>(null);

    React.useImperativeHandle(ref, () => ({
        onRequestClose: () => {
            if (popperElem.current) {
                popperElem.current.requestClose();
            }
        },
    }));

    const labelClasses = classNames({
        filters__filter: true,
        [`filters__filter--${id}`]: true,
    });
    const modalClasses = classNames({
        filters__dropdown: true,
        [`filters__dropdown--${id}`]: true,
    });

    return (
        <UncontrolledPopover
            ref={popperElem}
            triggerContent={labelText}
            triggerBtnProps={{
                className: labelClasses,
            }}
            popperOptions={{
                placement: "bottom",
            }}
            modalProps={{
                contentLabel: labelText,
                style: {
                    overlay: {
                        backgroundColor: "transparent",
                    },
                },
            }}
            onAfterOpen={onAfterOpen}
            onAfterClose={onAfterClose}
        >
            <div className={modalClasses}>{children}</div>
        </UncontrolledPopover>
    );
};
